import { Component, Input } from "@angular/core";

@Component({
    selector: "email-toggle-component",
    templateUrl: "./email-toggle.component.html",
})
export class EmailToggleComponent {
    @Input() receiveEmail = true;
}
